<template>
    <loading  v-if="creatingUser" :message="$t('INVITATION_LOADING_MESSAGE')"/>
    <v-alert v-else-if="error && !retryableError" role="alert" type="error" icon="error" dense :value="error" class="mb-4">{{ error }}</v-alert>
    <div v-else class="elevation-0">
        <h1>{{$t('INVITATION_CONFIRMATION')}}</h1>
        <template v-if="invitation.id">
            <v-alert v-if="error && retryableError" role="alert" type="error" icon="error" dense :value="error" class="mb-4">{{ error }}</v-alert>
            <announcement/>
            <p class="mt-3 mb-3">{{$t('INVITATION_WELCOME_TEXT', {name: invitation.name})}}</p>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
        </template>
        <template v-if="invitation.id">
            <login-buttons @confirm="onLoginSuccess" mode="invitations" :providers="['google', 'azure']"/>
        </template>
    </div>
</template>


<script lang="ts">
import Vue from "vue";
import { setTimeout } from "timers";
import Loading from "@utils/Loading.vue";
import { GoneApiClientError, NotFoundApiClientError } from "@cyber-range/cyber-range-api-client";
import LoginButtons from "../login/LoginButtons.vue";
import Announcement from "@utils/Announcement.vue";
import Component from "vue-class-component";
import { InvitationStatus, IInvitation } from '@cyber-range/cyber-range-api-invitation-client';
import Config from '@/config';
import AddUserMethod from "@/interfaces/addUserMethod";
import { CreateUserParams } from '../../utils/userCreation/createUserParams'
import { useErrorStore } from "@/stores/errorStore";
import { useApiClientStore } from "@/stores/apiClientStore";
import { useAuthenticationStore } from "@/stores/authenticationStore";
import { useUserStore } from "@/stores/userStore";
import { storeToRefs } from "pinia";

@Component({
    components: { Loading, LoginButtons, Announcement }
})
export default class Invitation extends Vue {
    get invitationApiClient() { return useApiClientStore().invitationApiClient; }
    get userApiClient() { return useApiClientStore().userApiClient; }
    get competitionApiClient() { return useApiClientStore().competitionApiClient; }
    getSsoToken = () => useAuthenticationStore().getSsoToken();
    tryLogin = () => useAuthenticationStore().tryLogin();
    
    // TODO: Change to composition api
    error = storeToRefs(useErrorStore()).errorMessage;
    // END TODO

    invitation :IInvitation = <IInvitation> {};
    creatingUser: boolean = false;
    retryableError: boolean = true;

    get invitationId() {
        return this.$route.params.iid;
    }

    async created() {
        try {
            this.invitation = await this.invitationApiClient.getOne(this.invitationId);
            if(this.invitation.status === InvitationStatus.PendingApproval || this.invitation.status === InvitationStatus.Rejected){
                let e : Error = new Error();
                e.message = this.invitation.status === InvitationStatus.PendingApproval
                            ? <string>this.$root.$t('INVITATION_PENDING_APPROVAL_MESSAGE')
                            : <string>this.$root.$t('INVITATION_REJECTED_MESSAGE');
                this.$router.push({ name: "login" });
                this.retryableError = false;
                useErrorStore().setError(e);
            }
        } catch (e) {
            if (e instanceof GoneApiClientError) {
                e.message = <string>this.$root.$t('INVITATION_ACCEPTED_ERROR_MESSAGE');
                this.$router.push({ name: "login", query: { redirect_url: e.location } });
            } else if (e instanceof NotFoundApiClientError) {
                e.message = <string>this.$root.$t('INVITATION_NOT_FOUND_ERROR_MESSAGE');
            }

            this.retryableError = false;
            useErrorStore().setError(e);
        }
    }

    async onLoginSuccess() {
        try {
            this.creatingUser = true;

            await useUserStore().createUser(new CreateUserParams(AddUserMethod.invitation, this.invitation));

        } catch(e) {
            //Do not set `creatingUser` back to true if all goes well. 
            //This is so that the loading kept showing until page redirection below.
            this.creatingUser = false; 

            if (e instanceof NotFoundApiClientError) {
                e.message = <string>this.$root.$t('COMPETITION_NOT_FOUND_ERROR_MESSAGE');
            }
            else
            {
                return;
            }
            this.retryableError = false;
            useErrorStore().setError(e);
        }
    }
}
</script>
